import styled from 'styled-components';

import { ScheduleMessage } from '../../../../../types/ScheduleMessage';
import { Text } from '../../../../cdl/Text/Text';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { Port } from '../../../../port/Port';
import { isCurrentPort } from '../utils/isCurrentPort';

import { PortCard } from './PortCard';
import { ScheduleStopTime } from './ScheduleStopTime';
import { ScheduleTimeline } from './ScheduleTimeline';

const TruncatedPortName = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;

    h3,
    div {
        display: inline;
    }
`;

interface ScheduleStopProps {
    stop: ScheduleMessage;
    vesselId: string;
    index: number;
    totalStops: number;
    firstStopIsCurrentStop?: boolean;
}

const getDisplayNumber = (index: number, isFirst: boolean, isCurrent: boolean, firstStopIsCurrentStop?: boolean) => {
    if (isFirst && isCurrent) {
        return null;
    }
    if (firstStopIsCurrentStop && !isFirst) {
        return index;
    }
    return index + 1;
};

export const ScheduleStop = ({ stop, vesselId, index, totalStops, firstStopIsCurrentStop }: ScheduleStopProps) => {
    const isFirst = index === 0;
    const isLast = index === totalStops - 1;
    const isCurrent = isFirst && isCurrentPort(stop);
    const displayNumber = getDisplayNumber(index, isFirst, isCurrent, firstStopIsCurrentStop);

    return (
        <Box position="relative">
            <ScheduleTimeline isFirst={isFirst} isLast={isLast} isCurrent={isCurrent} displayNumber={displayNumber} />

            <PortCard>
                <Box>
                    <TruncatedPortName>
                        <Text variant="body" fontWeight={600} as="h3">
                            {stop.port ? <Port port={stop.port} vesselId={vesselId} short /> : stop.locode}
                        </Text>
                    </TruncatedPortName>
                    {stop.port ? <Text variant="extraSmall">{stop.port.locCode}</Text> : null}
                </Box>

                <Box display="flex" flexDirection="column" gap={8}>
                    <ScheduleStopTime title={translate('schedule.arrival')} stop={stop} date={stop.eta} />
                    <ScheduleStopTime title={translate('schedule.departure')} stop={stop} date={stop.etd} />
                </Box>
            </PortCard>
        </Box>
    );
};
